import { EventSourceHandler } from '@sellsy/sse';

export default class OnboardingShouldFillTeamPositionEventSourceHandler extends EventSourceHandler {
    
    constructor(){
        super()
        this.type = 'staff.onboarding.should.fill.team.position'
    }

    handle(event){
        window.sellsyapp.$store.state.popupPanel.popupAprilTeamPosition.display = true
    }

}